module.exports = __webpack_public_path__ + "static/media/arrow.864ec2e2.svg";